/**
 * Columnas del listado "Secuencias" (VEC-3474), para `GridColumnSelector` y `useColumnVisibility` (src/commons/grid/).
 *
 * El orden es el del `thead`, y cada `messageId` es el del encabezado de la columna. `fixed: true` saca la columna del selector y la deja siempre
 * visible: el nombre identifica la fila y la última lleva los botones Ver y Editar (si se pudiera ocultar, el usuario perdería el acceso).
 */

export const SECUENCIAS_COLUMNAS_STORAGE_KEY = 'SecuenciasChecklistGrid_columnas';

export const buildSecuenciasColumns = () => [
	{ name: 'nombre', fixed: true },
	{ name: 'aplicaA', messageId: 'tipoFormularioSecuenciaGrid.column_APLICA_A.label', label: 'Aplica a vehículos en estado' },
	{ name: 'checklists', messageId: 'tipoFormularioSecuenciaGrid.column_PASOS.label', label: 'Checklists' },
	{ name: 'intentos', messageId: 'tipoFormularioSecuenciaGrid.column_INTENTOS.label', label: 'Intentos máx.' },
	{ name: 'activo', messageId: 'tipoFormularioSecuenciaGrid.column_ACTIVO.label', label: 'Activo' },
	{ name: 'acciones', fixed: true },
];
